var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThreeSpace = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none",
  viewBox: "0 0 25 25"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "three-space_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.616.183h24v24h-24z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  clipPath: "url(#three-space_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12.625,
  height: 4.68,
  x: 6.304,
  y: 9.843,
  rx: 1.016
}), /*#__PURE__*/React.createElement("rect", {
  width: 12.625,
  height: 4.68,
  x: 6.304,
  y: 2.78,
  rx: 1.016
}), /*#__PURE__*/React.createElement("rect", {
  width: 12.625,
  height: 4.68,
  x: 6.304,
  y: 16.905,
  rx: 1.016
}))));
export { SvgThreeSpace as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI1IiB2aWV3Qm94PSIwIDAgMjUgMjUiIHdpZHRoPSIyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBkPSJtLjYxNjIxMS4xODI2MTdoMjR2MjRoLTI0eiIvPjwvY2xpcFBhdGg+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiPjxyZWN0IGhlaWdodD0iNC42Nzk2OSIgcng9IjEuMDE1NjIiIHdpZHRoPSIxMi42MjUiIHg9IjYuMzAzNzEiIHk9IjkuODQyNzciLz48cmVjdCBoZWlnaHQ9IjQuNjc5NjkiIHJ4PSIxLjAxNTYyIiB3aWR0aD0iMTIuNjI1IiB4PSI2LjMwMzcxIiB5PSIyLjc4MDI3Ii8+PHJlY3QgaGVpZ2h0PSI0LjY3OTY5IiByeD0iMS4wMTU2MiIgd2lkdGg9IjEyLjYyNSIgeD0iNi4zMDM3MSIgeT0iMTYuOTA1MyIvPjwvZz48L3N2Zz4=";